module.exports = __webpack_public_path__ + "img/meta_tag_logo_podcast.b4ce435f.png";